<template>
  <div class="col-12">
    <div><h3>{{course.title}}</h3></div>
    <div><b>{{'Number of invites left' | translate}}:</b> {{ licencesLeft }}</div>
    <div><small>{{'If you want to participate - please add your email address below' | translate}}</small></div>

    <div class="my-5">
      <table class="table">
        <thead>
          <tr>
            <th class="border-0">{{'Name' | translate}}</th>
            <th class="border-0">Email</th>
            <th class="border-0">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invitation in invitations" :key="invitation.id">
            <td>{{ invitation.name }}</td>
            <td>{{ invitation.email }}</td>
            <td class="d-flex justify-content-between">
              <div>
                {{invitation.status | translate}}
              </div>
              <div
                v-if="invitation.status === 'sent'"
                @click="remove(invitation)"
              >
                <button class="btn btn-outline-danger btn-sm">X</button>
              </div>
            </td>
          </tr>
          <tr v-if="licencesLeft">
            <td>
              <input
                type="text"
                name=""
                class="form-control"
                :placeholder="$t('Name')"
                v-model="name"
              />
            </td>
            <td>
              <input
                type="text"
                name=""
                class="form-control"
                placeholder="Email"
                v-model="email"
              />
            </td>
            <td class="text-center">
              <button class="btn btn-outline-primary" @click="create">
                {{'Invite' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['course', 'transaction'],
  data() {
    return {
      invitations: this.transaction.child_invitations,
      name: '',
      email: '',
    }
  },
  methods: {
    remove(invitation) {
      Swal.fire({
        title: this.$t('Are you sure?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Delete'),
        cancelButtonText: this.$t('Cancel'),
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`/home/access-manager/${this.course.id}/${invitation.id}`)
            .then(({ data }) => {
              this.invitations = [
                ...this.invitations.filter((invite) => {
                  return invite.id !== invitation.id
                }),
              ]
            })
        }
      })
    },
    create() {
      axios
        .post(`/home/access-manager/${this.course.id}`, {
          course_id: this.course.id,
          parent_transaction_id: this.transaction.id,
          name: this.name,
          email: this.email,
        })
        .then(({ data }) => {
          this.email = ''
          this.name = ''
          this.invitations.push(data)
        })
    },
  },
  computed: {
    licencesLeft() {
      let left = this.transaction.quantity - this.invitations.length
      if (left > 0) {
        return left
      }
      return 0
    },
  },
}
</script>

<style></style>
